import { ethers } from 'ethers';

export function formatTickerOrAddress(
  name: string | undefined | null,
  leftLength = 6,
  rightLength = 4,
): string {
  if (name === undefined || name === null) return '';

  if (!ethers.isAddress(name)) return name;

  return `${name.slice(0, leftLength)}...${name.slice(-rightLength)}`;
}
